import DeviceService from "../../DeviceService";

/**
 * @doc https://gppi-docs.team.goreel.tech/replay.html?ts=1755782579284
 * @param query
 */
export const handleGoReelsReplayProtocol = (query: URLSearchParams) => {
    if (
        query.has("game_name")
        && query.has("round_from")
        && query.has("rounds")
        && Number(query.get("rounds") as string) >= 1
    ) {
        query.set("game", query.get("game_name") as string);
        query.set("key", `replay-${query.get("round_from")}`);

        if (Number(query.get("rounds") as string) > 1) {
            query.set("key", `replay-${query.get("round_from")}+${Number(query.get("rounds")) - 1}`);
        }

        const partner = query.get("wl") || query.get("partner");
        if (partner) {
            query.set("partner", partner);
        }

        if (!query.has("lang")) {
            query.set("lang", "en");
        }

        console.warn?.(`[booongo replay protocol]`, query.toString());
    }
}

export const handleGoReelsProtocol = (query: URLSearchParams) => {
    if (query.get("game") && query.get("wl") && query.get("token")) {
        query.set("partner", query.get("wl") as string);
        query.set("key", query.get("token") as string);
        query.set("gameName", query.get("game") as string);

        const platform = (() => {
            const mobile = query.get("mobile");
            if (!!mobile) {
                return mobile.trim() === "1" ? "mob" : "desk";
            }

            return DeviceService.isMobile() ? "mob" : "desk";
        })();

        query.set("platform", platform);

        console.warn?.(`[booongo protocol]`, query.toString());
    }
};
